'use strict'

import axios from 'axios'
import allFu from '../global/global'
import { Notification , MessageBox ,Loading } from 'element-ui' //使用elementui的提示显示
import router from "../router";
import base from './baseUrl'
import store from "../store";
import { Toast ,Dialog} from 'vant';
let loading
let showOut = false ;
let multiDevice = false ;
let showPower = false ;
let isMobile = '/login' ;
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    /*window.location.href="你的手机版地址";*/
    isMobile = '/wxLogin' ;
}
else {
    /*window.location.href="你的电脑版地址";    */
    isMobile = '/login' ;
}
function errMsg(title,message){
  if(isMobile == '/login'){
      Notification.warning({
        title: title,
        message: message
      })
  }else{
      Toast(message)
  }
}
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '',
    background: 'rgba(0, 0, 0, 0.1)',
    spinner:'el-icon-loading',
    customClass:'jiazai'
  })
}

function endLoading() {
  loading.close()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

export function removeStorageFn() {
    localStorage.removeItem("goin")
    localStorage.removeItem("authorization")
    localStorage.removeItem("logo")
    localStorage.removeItem("hotelData")
    localStorage.removeItem("hotelCode")
    localStorage.removeItem("userId")
    localStorage.removeItem("staffRoleAuthMd5")
    localStorage.removeItem("bellFlagTem")
    localStorage.removeItem("welcomeBellFlagTem")
    localStorage.removeItem("bellFlagCast")
    localStorage.removeItem("bellFlagAdm")
    localStorage.removeItem("bellFlagMan")
    localStorage.removeItem("warnFlagAdm")
    localStorage.removeItem("warnFlagCast")
    localStorage.removeItem("warnFlagChannel")
    localStorage.removeItem("warnFlagMan")
    localStorage.removeItem("warnFlagImg")
    localStorage.removeItem("warnFlagScr")
    localStorage.removeItem("warnFlagUrg")
    localStorage.removeItem("warnFlagVideo")
    store.commit('authorization','');
    store.commit('hotelCode','');
}

// axios.defaults.baseURL = '/apiAdmin'
// console.log(axios.defaults.baseURL,'/apiAdmin')
axios.defaults.timeout = 10000
axios.interceptors.request.use(config => {
  // console.log(config,'---config----')
  // 去掉不加load
  let filterUrl01 = 'webapi/trans/translate'  ;
  let filterUrl02 =  'webapi/hotel/list' ;
  if(config.url.indexOf(filterUrl01) == -1){
      // showFullScreenLoading();
  }else if(config.url.includes(filterUrl02) == -1){
      // showFullScreenLoading();
  }else{
    showFullScreenLoading();   // 不展示加载了。
  }

  setTimeout(()=>{
    tryHideFullScreenLoading()
  },8000)
  return config
}, err => {
  // console.log(err,'---error----')
  setTimeout(()=>{
    tryHideFullScreenLoading()
  },8000)
  return Promise.resolve(err)
})

axios.interceptors.response.use(response => {
  tryHideFullScreenLoading()
  // console.log(response,'--response 拦截响应code---111')
  if (response) {
    switch (response.data.code) {
      case 6: //与后台约定登录失效的返回码,根据实际情况处理
            break
    }

  }
  return response
}, err => {
  // console.log(err,'拦截响应错误222',err.response.status)
  let status = +err.response.status ;
  if(err.response.status !== 200){
      if(status>=500){
          errMsg('错误',"服务器异常，请稍后重试!");
      }
      removeStorageFn();
      setTimeout(()=>{
        tryHideFullScreenLoading()
      },200)

      router.replace({
        path: isMobile
      })
  }else{
    setTimeout(()=>{
      tryHideFullScreenLoading()
    },10000)
    return Promise.resolve(err);
  }

})
let userLogin = "" ;
export const postRequest = (url, params, Func, isJson, Func1) => {
  request(url, params, 'post', Func, isJson, Func1)
}
//是否正在刷新标记
let isRefresh = false;
// 重试队列，每一项将是一个待执行的函数形式
let requests = [];
export const request = (url, params, method, Func, isJson, Func1) => {
  // console.log(url, params, method,'------------userId--------------------')
  // 测试网址 mock
  let baseUrl = ""
  // if(url.indexOf('webapi/tj/online') !== -1){
  //   baseUrl = 'http://apidoc.tvplus.club/mock/254/'
  // }else{
  //   baseUrl = base ;
  // }
  baseUrl = base ;
  // 保证返回的还是一个promise对象
  let jsonParams = {}
  if(method == 'post' || method == 'POST'){
    if(url.indexOf('webapi/material/add') != -1 || url.indexOf('webapi/file/upload') != -1){
      jsonParams = params ;
    }else{
      jsonParams = allFu.allFu.isProduct() ? allFu.allFu.encryption(params) : params ;
    }
  }else{
      jsonParams = params ;
  }
  // 测试不加密
  // jsonParams = params ;
  return axios({
    method: method,
    url: `${baseUrl}${url}`,
    data:jsonParams ,
    headers: {
      'Content-Type': isJson === 1 ? 'application/json' : 'application/x-www-form-urlencoded',
      'authorization': store.state.login.authorization ||  localStorage.getItem('authorization'),
      "hotelcode": localStorage.getItem('hotelCode'), //这个是写死的
      "userid":localStorage.getItem('userId'),
      "routerMac":localStorage.getItem('visitorId'),
      'staffRoleAuthMd5':localStorage.getItem("staffRoleAuthMd5")
    }
  }).then(data => {
    // console.log(data.data,'data----数据')
    let deckData = allFu.allFu.isProduct() ? allFu.allFu.decrypt(data.data,'CKsH@Db00qONJo0b') : data.data ;
    if (deckData.code === 0) {
      Func(deckData);
    }
    else if(deckData.code == 12){
      errMsg('错误',"该手机号已经注册,请直接登录");
    }
    else if(deckData.code == 22){
      // errMsg('错误',deckData.msg);
      errMsg('错误','短信验证码有误，请重新输入');
      Func(deckData);
    }else if(deckData.code == 6){
          removeStorageFn();
          router.replace({
            path: isMobile
          })
    }else if(deckData.code == 8){
        console.log(showOut,'-----走了几次-----')
        if(isMobile == '/login'){
            if(!showOut){
                showOut = true ;
                console.log('---弹窗几次----')
                MessageBox.confirm('长时间未操作，请重新登录', '提示', {
                  closeOnClickModal:false,
                  confirmButtonText: '确定',
                  showCancelButton:false,
                  showClose:false,
                  type: 'warning',
                }).then(() => {
                  removeStorageFn();
                  router.replace({
                    path: isMobile
                  })
                  router.go(0);
                }).catch(() => {});
            }else{
              if(!localStorage.getItem('authorization')){
                removeStorageFn();
                router.replace({
                  path: isMobile
                })
              }
            }
        }else{
          if(!showOut){
              showOut = true ;
              console.log('---弹窗几次----')
              Dialog.alert({
                title: '提示',
                message: '长时间未操作，请重新登录',
              }).then(() => {
                removeStorageFn();
                router.replace({
                  path: isMobile
                })
                console.log(isMobile,'---- 当前跳转路由 ---')
                router.go(0);
              });
          }else{
              if(!localStorage.getItem('authorization')){
                removeStorageFn();
                router.replace({
                  path: isMobile
                })
              }
          }
        }



    }else if(deckData.code == 29){
        console.log(multiDevice,'-----您的账号已在其他设备登录，请重新登录-----')
        if(isMobile == '/login'){
            if(!multiDevice){
                multiDevice = true ;
                console.log('---弹窗几次----')
                MessageBox.confirm('您的账号已在其他设备登录，请重新登录', '提示', {
                  closeOnClickModal:false,
                  confirmButtonText: '确定',
                  showCancelButton:false,
                  showClose:false,
                  type: 'warning',
                }).then(() => {
                  removeStorageFn();
                  router.replace({
                    path: '/'
                  })
                  router.go(0);
                }).catch(() => {});
            }else{
              if(!localStorage.getItem('authorization')){
                removeStorageFn();
                router.replace({
                  path: '/'
                })
              }
            }
        }else{
            if(!multiDevice){
                multiDevice = true ;
                console.log('---弹窗几次mobile 29----')
                Dialog.alert({
                  title: '提示',
                  message: '您的账号已在其他设备登录，请重新登录',
                }).then(() => {
                  removeStorageFn();
                  router.replace({
                    path: '/'
                  })
                  router.go(0);
                });
            }else{
              if(!localStorage.getItem('authorization')){
                removeStorageFn();
                router.replace({
                  path: '/'
                })
              }
            }
        }


    }
    else if(deckData.code == 810){
      if(isMobile == '/login'){
        if(!multiDevice){
            multiDevice = true ;
            console.log('---弹窗几次----')
            MessageBox.confirm('当前权限已发生变化，请重新进入酒店', '提示', {
              closeOnClickModal:false,
              confirmButtonText: '确定',
              showCancelButton:false,
              showClose:false,
              type: 'warning',
            }).then(() => {
              setTimeout(()=>{
                 multiDevice = false ;
              },3000)
              console.log(router,'---- router -----')
              if(router.history.current.path == '/hotelList'){
                 router.go(0);
              }else{
                router.replace({
                  path: '/hotelList'
                })
              }

            }).catch(() => {});
        }
      }else{
        if(!multiDevice){
            multiDevice = true ;
            console.log('---弹窗几次----')
            Dialog.alert({
              title: '提示',
              message: '当前权限已发生变化，请重新进入酒店',
            }).then(() => {
              setTimeout(()=>{
                multiDevice = false ;
             },3000)
             console.log(router,'---- router -----')
             if(router.history.current.path == '/wxHotelList'){
                router.go(0);
             }else{
               router.replace({
                 path: '/wxHotelList'
               })
             }

            });
        }
      }

    }else if(deckData.code == 811){
      if(isMobile == '/login'){
        if(!multiDevice){
            multiDevice = true ;
            console.log('---弹窗几次----')
            MessageBox.confirm('酒店负责人已被禁用或删除', '提示', {
              closeOnClickModal:false,
              confirmButtonText: '确定',
              showCancelButton:false,
              showClose:false,
              type: 'warning',
            }).then(() => {
              setTimeout(()=>{
                 multiDevice = false ;
              },3000)
              console.log(router,'---- router -----')
              if(router.history.current.path == '/hotelList'){
                 router.go(0);
              }else{
                router.replace({
                  path: '/hotelList'
                })
              }

            }).catch(() => {});
        }
      }else{
        if(!multiDevice){
            multiDevice = true ;
            console.log('---弹窗几次----')
            Dialog.alert({
              title: '提示',
              message: '当前权限已发生变化，请重新进入酒店',
            }).then(() => {
              setTimeout(()=>{
                multiDevice = false ;
             },3000)
             console.log(router,'---- router -----')
             if(router.history.current.path == '/wxHotelList'){
                router.go(0);
             }else{
               router.replace({
                 path: '/wxHotelList'
               })
             }

            });
        }
      }

    }
    else if(deckData.code == 4 || deckData.code == 5){
        Func(deckData);
    }
    else if(deckData.code == 30 || deckData.code == 806 || deckData.code == 18 || deckData.code == 27 || deckData.code == 19 || deckData.code == 20){
      errMsg('错误',deckData.msg)
    }
    else if(deckData.code == 7 || deckData.code == 23 || deckData.code == 24 || deckData.code == 10){
        Func(deckData);
        errMsg('错误',deckData.msg)
        removeStorageFn();
        router.replace({
          path: isMobile
        })
    }else if(deckData.code == 807){
       if(!showPower){
          showPower = true ;
          errMsg('错误',"您已被禁止操作该酒店,请联系酒店负责人")
          removeStorageFn();
          router.replace({
            path: isMobile
          })
       }

    }else if(deckData.code == 808){
      if(!showPower){
        showPower = true ;
        errMsg('错误',"您已无法管理该酒店,请联系酒店负责人")
        removeStorageFn();
        router.replace({
          path: isMobile
        })
      }
    }
    else if (deckData.code == 25){
      Func(deckData);
      errMsg('错误',deckData.msg);
    }
    else {
      /*
       @params：code自定义状态码，每个函数可能不一样
       @params：message:后台提示信息
      */
      // Notification.error({
      //   title: '错误',
      //   message: data.data.msg
      // })
      Func(deckData, deckData.msg);
      setTimeout(()=>{
        tryHideFullScreenLoading()
      },10000)
    }
  }).catch(error => {
      if (Func1) {
          Func1(error)
      }
  })
}
export const putRequest = (url, params, Func, isJson) => {
  request(url, params, 'put', Func, isJson)
}
export const deleteRequest = (url, params, Func, isJson) => {
  request(url, params, 'delete', Func, isJson)
}
export const getRequest = (url, params, Func, isJson,Func1) => {
  request(url, params, 'get', Func, isJson,Func1)
}
export const uploadFileRequest = (url, params, fun) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    // transformRequest: [function (data) {
    //     return JSON.stringify(data)
    // }],
    headers: {
      'Content-Type': 'application/json',
      'authorization': store.state.login.authorization ||  localStorage.getItem('authorization'),
      "hotelcode": localStorage.getItem('hotelCode'),
      "userid":localStorage.getItem('userId'),
      'staffRoleAuthMd5':localStorage.getItem("staffRoleAuthMd5")
    }
  }).then(data => {
    let deckData = allFu.allFu.isProduct() ? allFu.allFu.decrypt(data.data,'CKsH@Db00qONJo0b') : data.data ;
    if (deckData.code === 0) {
      fun(deckData);
    }else if(deckData.code == 12){
      errMsg('错误',"该手机号已经注册,请直接登录")
    }
    else if(deckData.code == 22){
      fun(deckData);
      errMsg('错误',deckData.msg)
    }
    else if(data.data.code == 6){
        errMsg('错误',deckData.msg)
        removeStorageFn();
        router.replace({
          path: isMobile
        })
    }
    else if(deckData.code == 7 || deckData.code == 10){
      errMsg('错误',deckData.msg)
      removeStorageFn();
      router.replace({
        path: isMobile
      })
    }
    else {
      fun(deckData, deckData.msg);
    }
  }).catch(err => {
    console.warn("FBI WARNING:" + err)
  })
}
//后台直接返回的是文件
export const downFileRequest = (url, params, fun) => {
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params, //get请求传递的参数是params，`params` 是即将与请求一起发送的 URL 参数
    // 必须是一个无格式对象(plain object)或 URLSearchParams 对象,`data`是作为请求主体被发送的数据, 只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
    responseType: 'blob', //相应类型一定要设置为bolb
    headers: {
      'Content-Type': 'multipart/form-data',
      'authorization': userLogin,
      'token': localStorage.getItem('token'),
      "clientAppId": "1143052791856254977", //这个是写死的
    }
  }).then(data => {
    let blob = new Blob([data.data], {
      type: "application/vnd.ms-excel"
    }); // res就是接口返回的文件流了
    let objectUrl = URL.createObjectURL(blob);
    window.location.href = objectUrl;
  }).catch(err => {
    console.warn("FBI WARNING:" + err)
  })
}



// WEBPACK FOOTER //
// ./src/api/http.js